@if (client?.civilId && client?.id) {
  <div class="accordion-wrapper">
    <itfg-identity-verification #ivComp [client]="client"></itfg-identity-verification>
    <itfg-identity-verification-documents [client]="client" />
    <itfg-mi-report [client]="client"> </itfg-mi-report>
  </div>
}